export default __webpack_public_path__ + "static/python-icon-5cf2d4cd27dfda85da31387af69815a3.svg";